// extracted by mini-css-extract-plugin
module.exports = {"root":"_816264","featureTitle":"_1c2368","featureList":"_581e30","trainingOptions":"_d094e7"};